import React from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import { DialogContent, DialogTitle } from "@material-ui/core";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import WorkOrderActions from "../DefaultWorkOrdersPage/WorkOrderActions";
import WorkOrderDetailContent from "../DefaultWorkOrdersPage/WorkOrderDetailContent";
import useStyles from "./styles";

interface IProps {
  open: boolean;
  onClose: () => void;
  onEditClick: () => void;
  selectedWorkOrder: racehorse360.IWorkOrder;
  track: string;
  onUpdate: () => void;
}

const MobileWorkOrderOverlay = React.memo((props: IProps) => {
  const { open, onClose, selectedWorkOrder, onUpdate, onEditClick } = props;
  const classes = useStyles();

  const isEditable = ![
    racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_CANCELED,
    racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_COMPLETE,
    racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_CLOSED
  ].includes(selectedWorkOrder?.status);

  return (
    <Dialog
      open={open}
      fullScreen
      classes={{
        root: classes.root,
        paper: classes.workOrderDetailPaper,
        paperScrollPaper: classes.workOrderDetailScrollPaper
      }}
      onClose={onClose}
    >
      <DialogTitle className={classes.dialogTitle}>
        <span className={classes.titleText}>Work Order Detail</span>
        <IconButton
          color="primary"
          onClick={onClose}
          classes={{
            root: classes.closeButton
          }}
        >
          <CloseIcon className={"classes.icon"} />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        {selectedWorkOrder && (
          <WorkOrderDetailContent
            selectedWorkOrder={selectedWorkOrder}
            isEditable={isEditable}
          />
        )}
      </DialogContent>

      {isEditable && (
        <DialogActions
          classes={{
            root: classes.workOrderDetailActions
          }}
        >
          <WorkOrderActions
            onEditClick={onEditClick}
            onUpdate={onUpdate}
            workOrder={selectedWorkOrder}
            type={"plain"}
          />
        </DialogActions>
      )}
    </Dialog>
  );
});

export default MobileWorkOrderOverlay;
